import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ALERTS_TRANSACTION: MijnRoute = {
    path: 'transactie-notificatie',
    navigationEvent: 'toTransactieNotificaties',
    regex: /^\/zelf-regelen\/notificaties-beheren\/transactie-notificatie$/,
    webcomponent: 'mijn-klant-notificatie-beheer-webcomponent',
    internalPath: '/transactie-notificatie/:id'
};
